import React from 'react'

const NotFound = () => {
  return (
    <div className='flex items-center justify-center w-screen h-screen bg-slate-900'>
      <div className='text-lg font-semibold text-white'>Tidak Ada Undangan Disini!</div>
    </div>
  )
}

export default NotFound